import React from 'react';

export const DayNightBlindTop = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg
      data-name="Layer 1"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 99.56 65.79"
      {...props}
    >
      <g data-name="Group 74">
        <g data-name="Group 72">
          <g data-name="Group 457">
            <path
              data-name="Rectangle 158"
              style={{
                fill: '#fff',
              }}
              d="M7.3 4.84h85.14v60.25H7.3z"
            />
            <path
              data-name="Path 2286"
              d="M92.43 65.79H7.3a.7.7 0 0 1-.7-.7V4.84a.69.69 0 0 1 .7-.69h85.13a.69.69 0 0 1 .7.69v60.25a.69.69 0 0 1-.69.69ZM8 64.4h83.74V5.53H8Z"
              style={{
                fill: '#dbd8d5',
              }}
            />
          </g>
          <g data-name="Group 458">
            <path
              data-name="Rectangle 159"
              style={{
                fill: '#fff',
              }}
              d="M7.3 4.84h85.14v60.25H7.3z"
            />
            <path
              data-name="Path 2287"
              d="M92.43 65.79H7.3a.7.7 0 0 1-.7-.7V4.84a.69.69 0 0 1 .7-.69h85.13a.69.69 0 0 1 .7.69v60.25a.69.69 0 0 1-.69.69ZM8 64.4h83.74V5.53H8Z"
              style={{
                fill: '#dbd8d5',
              }}
            />
          </g>
          <g data-name="Group 459">
            <path
              data-name="Rectangle 160"
              style={{
                fill: '#dbd8d5',
              }}
              d="M11.27 8.81h77.19v52.3H11.27z"
            />
            <path
              data-name="Path 2288"
              d="M88.46 61.81H11.27a.7.7 0 0 1-.7-.69V8.82a.7.7 0 0 1 .7-.7h77.19a.69.69 0 0 1 .69.7v52.3a.7.7 0 0 1-.69.7ZM12 60.43h75.77V9.51H12Z"
              style={{
                fill: '#dbd8d5',
              }}
            />
          </g>
          <path
            data-name="Path 2289"
            d="M96.73 65.75H3a.66.66 0 0 1-.65-.66.65.65 0 0 1 .65-.65h93.73a.65.65 0 0 1 .65.65.66.66 0 0 1-.65.66Z"
            style={{
              fill: '#dbd8d5',
            }}
          />
        </g>
        <g data-name="Group 73">
          <g data-name="Group 460">
            <g data-name="Rectangle 161">
              <path
                style={{
                  fill: '#929497',
                }}
                d="M3.97 1.59h91.6V53.7H3.97z"
              />
              <path
                d="M95.36 1.81v51.67H4.2V1.81h91.16m.44-.44h-92v52.55h92V1.37Z"
                style={{
                  fill: '#fff',
                }}
              />
            </g>
            <path
              data-name="Path 2290"
              d="M95.78 54h-92V1.27h92ZM4.61 52.94h90.33V2.35H4.61Z"
              style={{
                fill: '#fff',
              }}
            />
          </g>
          <g data-name="Group 460">
            <path
              data-name="Rectangle 161"
              style={{
                fill: '#101345',
              }}
              d="M4.2 1.65h91.16v35.91H4.2z"
            />
            <path
              data-name="Path 2290"
              d="M95.78 37.93h-92V1.27h92Zm-91.17-.74h90.33V2H4.61Z"
              style={{
                fill: '#fff',
              }}
            />
          </g>
          <g data-name="Group 461">
            <g data-name="Rectangle 162">
              <path
                style={{
                  fill: '#929497',
                }}
                d="M3.54 52.21h92.47v1.8H3.54z"
              />
              <path
                d="M95.79 52.43v1.36h-92v-1.36h92m.44-.44H3.32v2.24h92.91V52Z"
                style={{
                  fill: '#fff',
                }}
              />
            </g>
            <path
              data-name="Path 2291"
              d="M96 54H3.53v-1.79H96Zm-92-.43h91.57v-.91H4Z"
              style={{
                fill: '#fff',
              }}
            />
          </g>
          <g data-name="Group 461">
            <path
              data-name="Rectangle 162"
              style={{
                fill: '#101345',
              }}
              d="M3.76 36.51h92.03v1.36H3.76z"
            />
            <path
              data-name="Path 2291"
              d="M96 38.09H3.53v-1.81H96Zm-92-.45h91.57v-.91H4Z"
              style={{
                fill: '#fff',
              }}
            />
          </g>
          <path
            data-name="Path 2292"
            d="M97.5 51.49a.39.39 0 0 1-.4-.39v-1.56a.4.4 0 1 1 .79 0v1.56a.39.39 0 0 1-.39.39Zm0-3.14a.4.4 0 0 1-.4-.4v-1.58a.4.4 0 1 1 .79 0V48a.4.4 0 0 1-.39.35Zm0-3.17a.4.4 0 0 1-.4-.4V43.2a.4.4 0 1 1 .79 0v1.58a.4.4 0 0 1-.39.4Zm0-3.17a.4.4 0 0 1-.4-.4V40a.4.4 0 1 1 .79 0v1.58a.4.4 0 0 1-.39.42Zm0-3.17a.4.4 0 0 1-.4-.4v-1.58a.4.4 0 1 1 .79 0v1.58a.4.4 0 0 1-.39.4Zm0-3.17a.4.4 0 0 1-.4-.4v-1.58a.4.4 0 1 1 .79 0v1.58a.4.4 0 0 1-.39.4Zm0-3.17a.4.4 0 0 1-.4-.4v-1.58a.4.4 0 1 1 .79 0v1.58a.4.4 0 0 1-.39.4Zm0-3.17a.4.4 0 0 1-.4-.4v-1.59a.4.4 0 0 1 .79 0v1.59a.4.4 0 0 1-.39.4Zm0-3.17a.4.4 0 0 1-.4-.4v-1.59a.4.4 0 0 1 .79 0v1.59a.4.4 0 0 1-.39.4Zm0-3.17a.4.4 0 0 1-.4-.4V21a.4.4 0 0 1 .79 0v1.59a.4.4 0 0 1-.39.41Zm0-3.17a.4.4 0 0 1-.4-.4v-1.59a.4.4 0 0 1 .79 0v1.59a.4.4 0 0 1-.39.4Zm0-3.18a.39.39 0 0 1-.4-.39v-1.59a.4.4 0 0 1 .79 0v1.59a.39.39 0 0 1-.39.39Zm0-3.17a.39.39 0 0 1-.4-.39v-1.59a.4.4 0 0 1 .79 0v1.59a.39.39 0 0 1-.39.39Zm0-3.17a.39.39 0 0 1-.4-.39V8.32a.4.4 0 0 1 .79 0v1.59a.39.39 0 0 1-.39.39Zm0-3.17a.39.39 0 0 1-.4-.39V5.15a.4.4 0 0 1 .79 0v1.59a.39.39 0 0 1-.39.39Z"
            style={{
              fill: '#101345',
            }}
          />
          <g data-name="Group 462">
            <path
              data-name="Rectangle 163"
              style={{
                fill: '#101345',
              }}
              d="M2.07 1.69h96.65v4.29H2.07z"
            />
            <path
              data-name="Path 2293"
              d="M99.13 6.4H1.64V1.27h97.49ZM2.49 5.56h95.8V2.11H2.49Z"
              style={{
                fill: '#fff',
              }}
            />
          </g>
          <g data-name="Group 463">
            <path
              data-name="Rectangle 164"
              d="M97.5.36a1.71 1.71 0 0 1 1.7 1.71v3.54a1.7 1.7 0 0 1-1.7 1.7 1.71 1.71 0 0 1-1.71-1.7V2.07A1.72 1.72 0 0 1 97.5.36Z"
              style={{
                fill: '#101345',
              }}
            />
            <path
              data-name="Path 2294"
              d="M97.5 7.68a2.08 2.08 0 0 1-2.07-2.07V2.07a2.07 2.07 0 1 1 4.13 0v3.54a2.07 2.07 0 0 1-2.06 2.07Zm0-6.95a1.34 1.34 0 0 0-1.34 1.34v3.54a1.34 1.34 0 0 0 2.68 0V2.07A1.34 1.34 0 0 0 97.5.73Z"
              style={{
                fill: '#fff',
              }}
            />
          </g>
          <g data-name="Group 464">
            <path
              data-name="Rectangle 165"
              d="M2.07.36a1.71 1.71 0 0 1 1.7 1.71v3.54a1.7 1.7 0 0 1-1.7 1.7 1.71 1.71 0 0 1-1.71-1.7V2.07A1.72 1.72 0 0 1 2.07.36Z"
              style={{
                fill: '#101345',
              }}
            />
            <path
              data-name="Path 2295"
              d="M2.07 7.68A2.08 2.08 0 0 1 0 5.61V2.07a2.07 2.07 0 1 1 4.13 0v3.54a2.07 2.07 0 0 1-2.06 2.07Zm0-6.95A1.34 1.34 0 0 0 .73 2.07v3.54a1.34 1.34 0 0 0 2.68 0V2.07A1.34 1.34 0 0 0 2.07.73Z"
              style={{
                fill: '#fff',
              }}
            />
          </g>
        </g>
      </g>
    </svg>
  );
};
